import { Scaffold } from 'layouts';
import { PaginatedOrders } from 'components/Pages/Scheduling';
import { PageProps } from 'types/global';

export const ListOrdersPage: React.FC<PageProps> = (props) => (
  <Scaffold {...props}>
    <PaginatedOrders />
  </Scaffold>
);
